import React from "react";

import SeletorPessoa from "./SeletorPessoa";

// Linha "Para: <pessoa>" embaixo de cada produto do carrinho do garçom.
export default function DonoDoItem({ donos, item }) {
  if (!donos.ligado) return null;
  const id = item.cartItemId || item.id;
  return (
    <SeletorPessoa
      valor={item._cliente_id}
      pessoas={donos.pessoas}
      podeCriar
      onEscolher={(cliente, nome) => donos.escolher(id, cliente, nome)}
      onNova={() => donos.pedirNova(id)}
    />
  );
}
